export default "__VITE_ASSET__CJRtI$qD__"